import TProfileEditSms from './index.vue';

TProfileEditSms.install = app => {
  app.component(TProfileEditSms.name, TProfileEditSms);
};

export default TProfileEditSms;
